<template>
    <label class="custom-control custom-checkbox" :class="{ 'has-error': hasError }" :name="name">
        <input type="checkbox" class="custom-control-input" v-model="innerValue" >
        <span class="custom-control-indicator"></span>
    </label>
</template>

<script>
    import ValueForwarder from '~/mixins/value-forwarder'

    export default {
        name: 'ad-checkbox',
        mixins: [
            ValueForwarder,
        ],

        data() {
            return {}
        },

        props: {
            name: {
                required: true,
            },
            properties: {
                required: false,
                default: () => {
                    return {};
                },
            },
            value: {
                required: false,
                default: null,
            },
            options: {
                required: false,
            },
        },

        watch: {
            value(newVal, oldVal) {
                this.$emit('input', newVal);
            }
        }
    };
</script>

<style scoped>

</style>
